import React, { useState, useEffect } from "react";
import styled from "styled-components";
import KanbanView from "../../Components/Kanban/KanbanView";
import TaskList from "../../Components/TaskList/TaskList";
import Calendar from "../../Components/Calendar/Calendar";
import filterSign from "../../Images/filterSign.svg";
import Modal from "../../Components/Kanban/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import NewLeadForm from "../../Components/Kanban/LeadForm/NewLeadForm";
import CardInfo from "../../Components/Kanban/Card/CardINfo/CardInfo";
import { useSession } from "../../authentications/SessionContext";
import Orangetasklist from "../../Images/Orangetasklist.svg";
import OrangeGrey from "../../Images/OrangeGrey.svg";
import kanbanGrey from "../../Images/kanbanGrey.svg";
import kanban from "../../Images/kanban.svg";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import ReactSelect from "react-select";
import {
  addCardsList,
  CrmAction,
  removeCard,
} from "../../Redux/Reducers/CrmSlice";
import { searchRead } from "../../DataApi/search_read";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { unLink } from "../../DataApi/unlink";
import TableLoader from "../../Components/Loaders/TableLoader";

const KanbanTypeFilterListOption = [
  { label: "All ", value: "" },
  {
    label: "Won",
    value: JSON.stringify([
      ["active", "=", true],
      ["stage_id.is_won", "=", true],
    ]),
  },
  {
    label: "Lost",
    value: JSON.stringify([
      ["active", "=", false],
      ["probability", "=", 0],
    ]),
  },
];
const KanbanSortListOption = [
  { label: "Default", value: "create_date" },
  { label: "Id", value: "id" },
  { label: "Name", value: "name" },
  { label: "Email", value: "email_from" },
  { label: "City", value: "city" },
  { label: "Date", value: "activity_date_deadline_my" },
  { label: "Partner Name", value: "contact_name" },
  { label: "Stage Name", value: "stage_id" },
  { label: "Stage Id", value: "stage_id" },
];

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 9px;
  .btn-group {
    width: 240px;
    background-color: #f8f9fa !important;
  }
`;
const KanbanFirstSec = styled.div`
  display: flex;
  gap: 30px;
  margin-left: 12px;

  .Filter_icon_div {
    width: 50px;
    height: 47px !important;
    border-radius: 30% !important;
    background-color: #f8f9fa !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-left: 10px;
  }
  .dropdown_list_div {
    background-color: #f8f9fa;
    height: 45px;
    color: #b0b7c3;
    font-size: 14px;
    font-family: "Inter";
    border-radius: 14px;
    border: none;
    background-color: #f8f9fa;
    padding: 6px;
    border: none;
    margin-left: 10px;
  }
  .dropdown_list_div select {
    padding: 4px 14px;
    background-color: transparent;
    border: 0;
    color: #000000;
    font-size: 16px;
    width: auto;
    font-family: "Inter";
    &:focus {
      border: none;
      outline: none;
    }
  }

  option {
    font-size: 16px;
    line-height: 6;
    padding: 12px !important;
    font-family: "Inter";
    margin: 10px !important;
  }
  .sort_by {
    margin-top: 6px;
    margin-right: 10px;
    font-size: 16px;
  }
  .reactSelect {
    margin-right: 10px;
  }
  .Filter_icon_div img {
    transition: transform 0.3s ease;
  }
`;

const NewButton = styled.button`
  border-radius: 15px;
  background-color: #ff5837;
  color: #ffffff;
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 20px;
`;
const CustomButton = styled.button`
  &&&.custom-button {
    background-color: ${(props) => (props.active ? "#fff" : "#fff")};
    border: none;
    border-radius: 32%;
    height: 38px;
    width: 38px;
    display: flex;
    margin: 10px;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
    &:hover {
      background-color: #fff;
    }
  }
`;
const Image = styled.img`
  &&&.custom-image {
    width: 100%;
    height: 100%;
    )};
  }
`;

const CRM = () => {
  const { changeview, selectedView, sessionInfo, searchQuery } = useSession();
  const { company_id, context } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [defaultEdit, setDefaultEdit] = useState(false);
  const { boards: groupedBoards, loading } = useSelector((state) => state.crm);
  const [selectedStageId, setSelectedStageId] = useState("");
  const [selectedLead, setSelectedLead] = useState({});
  const [newLeadModalType, setNewLeadModalType] = useState("add");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  // const { changeview, selectedView, sessionInfo } = useSession();
  const [OrderTypeFilter, setOrderTypeFilter] = useState(
    KanbanTypeFilterListOption[0]
  );
  const [filterDirection, setFilterDirection] = useState("desc");

  const [KanbanSorting, setKanbanSorting] = useState(
    KanbanSortListOption[0].value
  );
  const dispatch = useDispatch();

  // const handleChangeSearch = (e) => {
  //   setSearchType(e.target.value);
  //   setSearchWithType(e.target.value);
  //   console.log("Search type:", e.target.value);
  // };
  const handleCreateClick = ({ stageId = "1", type = "add", card = {} }) => {
    setSelectedStageId(stageId);
    setNewLeadModalType(type);
    setSelectedLead({ ...card });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedStageId("");
  };
  const handleClose = () => {
    setIsCreateModalOpen(false);
  };
  const getSelectedStageID = () => {
    if (selectedStageId) {
      return selectedStageId;
    }
    if (selectedView === "kanbanView") {
      return groupedBoards?.[0]?.stage_id;
    }
    if (selectedView === "taskList") {
      return groupedBoards?.records?.stage_id?.[0];
    }
  };

  const handleChangekanbanTYpeFilter = (value, e) => {
    setOrderTypeFilter(value);
  };

  const handleRemoveCard = async (stageId, cardId) => {
    let response = await unLink({
      id: cardId,
      company_id,
      context,
      model: "crm.lead",
    });
    response = JSON.parse(response);
    if (response?.result) {
      dispatch(removeCard({ stageId, cardId }));
    }

    return response;
  };

  const handleChangeKanbanSortingType = (e) => {
    setKanbanSorting(e.target.value);
  };

  const handleLoadMoreData = async (stage_id, offset, handleChangeOffset) => {
    let response = await searchRead(
      company_id,
      context,
      selectedView,
      [
        "&",
        ["stage_id", "=", stage_id],
        "&",
        ["type", "=", "opportunity"],
        ["user_id", "=", context.uid],
      ],
      "",
      {
        limit: PAGINATION_DEFAULT_LIMIT,
        offset: (offset + 1) * PAGINATION_DEFAULT_LIMIT,
      }
    );
    response = JSON.parse(response);
    if (response?.result?.records) {
      dispatch(
        addCardsList({
          stageId: stage_id,
          cardsList: response?.result?.records,
        })
      );

      handleChangeOffset(1);
      return;
    }
    handleChangeOffset(0);
  };
  const handleSelectStageId = ({ id }) => {
    setSelectedStageId(id);
  };
  const handleChangeKanbanSorting = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const refetchData = (startEndDate = null, offset = 0, search = "") => {
    dispatch(
      CrmAction.fetchCRMData({
        company_id,
        context,
        selectedView,
        startEndDate,
        pagination: {
          limit: PAGINATION_DEFAULT_LIMIT,
          offset,
        },
        search: {
          query: search,
          type: OrderTypeFilter?.value || "",
        },
        sort: {
          type: KanbanSorting || "",
          dir: filterDirection,
        },
      })
    );
  };
  // Data fetching
  useEffect(() => {
    refetchData();
  }, [
    dispatch,
    selectedView,
    company_id,
    context,
    searchQuery,
    OrderTypeFilter,
    KanbanSorting,
    filterDirection,
  ]);

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <NewLeadForm
          selectedLead={selectedLead}
          stageId={getSelectedStageID()}
          handleCloseModal={handleCloseModal}
          refetchData={refetchData}
          modalType={newLeadModalType}
          setModalType={setNewLeadModalType}
          setDefaultEdit={setDefaultEdit}
          defaultEdit={defaultEdit}
        />
      </Modal>
      {isCreateModalOpen && (
        <Modal isOpen={isCreateModalOpen} onCloseModal={handleClose}>
          <CardInfo />
        </Modal>
      )}

      <div className="d-flex justify-content-between p-2 mt-3">
        <KanbanFirstSec>
          {selectedView !== "timeoff" && (
            <div className="d-flex  d-none d-md-flex ">
              <div className=" reactSelect ">
                <ReactSelect
                  value={OrderTypeFilter}
                  options={KanbanTypeFilterListOption}
                  name="type"
                  onChange={handleChangekanbanTYpeFilter}
                />
              </div>

              <div className=" d-none d-md-flex dropdown_list_div d-flex">
                <div className="sort_by">Sort by:</div>

                <select
                  className="custom-select"
                  onChange={handleChangeKanbanSortingType}
                  value={KanbanSorting}
                  name="type"
                >
                  {KanbanSortListOption.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                      style={{ padding: "15px 0" }}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="Filter_icon_div">
                <img
                  src={filterSign}
                  alt="filter"
                  style={{
                    transform: `rotate(${
                      filterDirection === "asc" ? "180" : "0"
                    }deg)`,
                  }}
                  onClick={handleChangeKanbanSorting}
                />
              </div>
            </div>
          )}
        </KanbanFirstSec>
        <ButtonContainer className="d-flex align-items-center">
          <NewButton onClick={handleCreateClick}>+ {t["Add new"]}</NewButton>
          <div className="btn-group" role="group" aria-label="Basic example">
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "kanbanView" ? "active" : ""
              }`}
              active={selectedView === "kanbanView" ? "true" : "false"} // Pass as string
              onClick={() => changeview("kanbanView")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={selectedView === "kanbanView" ? kanban : kanbanGrey}
                  alt="Profile Image"
                />
              </div>
            </CustomButton>
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "taskList" ? "active" : ""
              }`}
              active={selectedView === "taskList" ? "true" : "false"}
              onClick={() => changeview("taskList")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={
                    selectedView === "taskList" ? Orangetasklist : OrangeGrey
                  }
                />
              </div>
            </CustomButton>
            <CustomButton
              type="button"
              className={`btn btn-custom custom-button ${
                selectedView === "timeoff" ? "active" : ""
              }`}
              active={selectedView === "timeoff" ? "true" : "false"}
              onClick={() => changeview("timeoff")}
            >
              <div>
                <Image
                  className="custom-image"
                  src={
                    selectedView === "timeoff"
                      ? require("../../Images/Calender.png")
                      : require("../../Images/CalendarG.png")
                  }
                  alt="Profile Image"
                />
              </div>
            </CustomButton>
          </div>
        </ButtonContainer>
      </div>
      {selectedView === "kanbanView" ? (
        <TableLoader isLoading={loading === "pending"}>
          <KanbanView
            handleSelectStageId={handleSelectStageId}
            handleLoadMore={handleLoadMoreData}
            handleCreateLead={handleCreateClick}
            isModalOpen={isModalOpen}
            handleCloseModal={handleCloseModal}
            handleRemoveCard={handleRemoveCard}
          />
        </TableLoader>
      ) : selectedView === "timeoff" ? (
        <Calendar refetchData={refetchData} />
      ) : (
        <TaskList
          refetchData={refetchData}
          setIsModalOpen={setIsModalOpen}
          setSelectedLead={setSelectedLead}
          setDefaultEdit={setDefaultEdit}
        />
      )}
    </div>
  );
};

export default CRM;
